import { Link } from "react-router-dom";
import Logo from "@/components/site/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-[#2A3042] bg-[#090A0F] relative grain">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 relative z-10">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div className="max-w-sm">
            <Logo />
            <p className="mt-4 text-[#9BA1B0] leading-relaxed">
              Every place has a story. Turn the places that matter into
              clues, quests and unforgettable unlocks.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-12">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#FF453A] mb-4">Explore</p>
              <div className="flex flex-col gap-3">
                <Link to="/how-it-works" className="text-[#9BA1B0] hover:text-white text-sm transition-colors">How It Works</Link>
                <Link to="/use-cases" className="text-[#9BA1B0] hover:text-white text-sm transition-colors">Use Cases</Link>
                <Link to="/privacy" className="text-[#9BA1B0] hover:text-white text-sm transition-colors">Privacy</Link>
              </div>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#FF453A] mb-4">Join</p>
              <div className="flex flex-col gap-3">
                <Link to="/early-access" data-testid="footer-early-access-link" className="text-[#9BA1B0] hover:text-white text-sm transition-colors">Get Early Access</Link>
                <Link to="/privacy-policy" data-testid="footer-privacy-policy-link" className="text-[#9BA1B0] hover:text-white text-sm transition-colors">Privacy Policy</Link>
                <Link to="/terms" data-testid="footer-terms-link" className="text-[#9BA1B0] hover:text-white text-sm transition-colors">Terms & Conditions</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-[#2A3042] flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-[#5a6070]">© {new Date().getFullYear()} PinQuests.com — Every place has a story.</p>
          <p className="text-xs text-[#5a6070]">PinQuests never shares your real-time location. Ever.</p>
        </div>
      </div>
    </footer>
  );
}
